module.exports = __webpack_public_path__ + "static/media/freight-people-logo-c.f8da7b44.png";